/* Friky: complementos de producto (add-ons como la caja de Funkos). Sustituye a la app Aris.
   Los checkbox los pinta el tema desde el metacampo custom.complementos. Al añadir el producto al
   carrito, se añaden también TODOS los complementos marcados (1 por unidad) como líneas aparte. */
(function () {
  var CAP = 20;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
    var checks = [].slice.call(form.querySelectorAll('.friky-caja-check')).filter(function (c) { return c.checked; });
    if (!checks.length) return;                              // ningún complemento marcado → flujo normal
    if (form.__frikyCajaDone) { form.__frikyCajaDone = false; return; } // 2ª pasada: dejar añadir el producto

    e.preventDefault();
    e.stopImmediatePropagation();

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (qty > CAP) qty = CAP;
    var items = checks.map(function (c) {
      return { id: Number(c.getAttribute('data-caja-variant')), quantity: qty, properties: { 'Complemento': FT('Añadido con tu producto') } };
    }).filter(function (it) { return it.id; });

    var proceed = function () { form.__frikyCajaDone = true; if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit(); };
    if (!items.length) { proceed(); return; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).catch(function () {}).finally(proceed);
  }, true);
})();

